import { render, staticRenderFns } from "./DSList.vue?vue&type=template&id=47a92c24&"
import script from "./DSList.vue?vue&type=script&lang=js&"
export * from "./DSList.vue?vue&type=script&lang=js&"
import style0 from "./DSList.vue?vue&type=style&index=0&id=47a92c24&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports